import { Button, Checkbox } from "antd";
import styled, { css } from "styled-components";

export const StyledContainer = styled.div<{ $accent?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;

    ${({ $accent }) =>
        $accent
            ? css`
                  &::before {
                      position: absolute;
                      content: "";
                      left: -16px;
                      width: 3px;
                      height: 100%;
                      background-color: ${({ theme }) => theme.colors.warning};
                  }
              `
            : null}
`;

export const StyledCheckbox = styled(Checkbox)<{
    $isActive?: boolean;
    $pending?: boolean;
}>`
    ${({ theme, $pending }) => {
        const color = $pending
            ? theme.additionalTypographyColor
            : theme.colors.green;

        return css`
            .ant-checkbox-checked {
                background-color: ${color} !important;
                border-color: ${color} !important;
            }

            .ant-checkbox-checked::after {
                border-color: ${({ theme }) => theme.colors.white};
            }
        `;
    }};

    .ant-checkbox {
        width: 18px;
        height: 18px;
        border: 2px solid ${({ theme }) => theme.checkboxBorder};

        background-color: ${({ theme, $isActive }) =>
            $isActive
                ? theme.secondaryBackgroundColor
                : theme.inactiveTabColor};
        opacity: ${({ $isActive }) => ($isActive ? 1 : 0.2)};
    }
`;

export const StyledMBTaskLabel = styled(Button)<{
    $isActive: boolean;
    $isTaskDirty: boolean;
}>`
    padding: 0;
    height: auto;
    font-size: 16px;

    color: ${({ $isActive, $isTaskDirty, theme }) => {
        if ($isActive && $isTaskDirty) {
            return theme.colors.warning;
        }

        if ($isActive) {
            return theme.primaryTypographyColor;
        }

        return theme.disabledTypographyColor;
    }} !important;
`;
